import React from "react";
import "./post.css";
import { normalizeComposition } from "./compositions";
import { FeaturePost } from "./compositions/FeaturePost";
import { GalleryPost } from "./compositions/GalleryPost";
import { JournalPost } from "./compositions/JournalPost";
import { GroundingPost } from "./compositions/GroundingPost";
import { WineTastingPost } from "./compositions/WineTastingPost";
import { RecipePost } from "./compositions/RecipePost";

const compositions = {
  journal: JournalPost,
  feature: FeaturePost,
  gallery: GalleryPost,
  grounding: GroundingPost,
  wine_tasting: WineTastingPost,
  recipe: RecipePost,
};

export function PostRenderer({ post, onEdit }) {
  if (!post) return null;
  const key = normalizeComposition(post.composition, { postType: post.post_type });
  const Composition = compositions[key] || compositions.journal;
  return <Composition post={post} onEdit={onEdit} />;
}

export default PostRenderer;
